import TestimonialCard from "components/TestimonialCard";
import React, { useEffect, useState } from "react";
import testimonios from '../data/testimonios.json';
// import testimoniosNiños from '../data/testimonios-niños.json';

function Testimonios() {
  const [testimonial,setTestimonial] = useState([]);
  useEffect(()=>{
    setTestimonial(testimonios);
  })
  return (
    <section className="bg-secundario">
      <div className=" flex flex-col bg-primario text-secundario">
        <div className="flex flex-col m-40 justify-end h-[30vh]">
          <h1 className="pt-32 text-9xl font-Bebas font-bold text-center tracking-wider">Testimonios</h1>
        </div>
      </div>
      <div className="m-40">
        <p className="text-3xl w-3/4 mx-auto text-center">
          Conoce las experiencias de nuestros estudiantes y lo que dicen sobre {" "}
          <strong>Brighton Centro de Inglés</strong>. ¿Listo para escribir tu próximo capítulo?
        </p>

      </div>
      <div className="grid grid-cols-2 w-3/4 gap-10 mx-auto pb-40">
        {testimonial.map((testimonio) => (
          <TestimonialCard key={testimonio.id} testimonio={testimonio}/>
        ))}
      </div>
    </section>
  );
}

export default Testimonios;
